"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_1 = require("react");
var Header_1 = require("./Header");
var App_1 = require("./App");
var Authenticator = function (props) {
    var context = react_1.useContext(App_1.LanguageContext);
    return (React.createElement("div", null,
        React.createElement(Header_1.default, __assign({ setLanguage: context.setLanguage }, props)),
        React.createElement("div", null,
            React.createElement("img", { src: require('../greenBackground.jpg'), className: 'img-responsive', width: '100%', style: { height: '95vh' } }))));
};
exports.default = Authenticator;
//# sourceMappingURL=Authenticator.js.map